import React, { useEffect, useMemo, useRef, useState } from 'react';
import locales from '../../../content.json';
import { Logo } from '../logo';
import { analyticsEventsTracker, GTMOnboardingFunnelEvent, EVENT_TRACKERS } from '../../../utils/analytics';
import { getParameterFromURL } from '../../../utils/scripts';

import s from './index.module.scss';

import imgEN from './img/imgEN.png';
import imgES from './img/imgES.png';
import imgRU from './img/imgRU.png';
import imgENDark from './img/imgENDark.png';
import imgESDark from './img/imgESDark.png';
import imgRUDark from './img/imgRUDark.png';

function SuccessScreen({ email, url, upselPDF }) {
  const autoRedirect = true;
  const emailRef = useRef(null);
  const emailRef2 = useRef(null);
  const [language, setLanguage] = useState(navigator.language || "en");
  const darkTheme = getParameterFromURL('darkTheme');
  
  if (autoRedirect) {
    setTimeout(() => {
      goToPayment();
    }, 14000);
  }

  function goToPayment() {
    analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.goToAccount(), EVENT_TRACKERS.GTM);
    setTimeout(() => {
      window.location.replace(url);
    }, 1000);
  }

  useEffect(() => {
    const emailElem = emailRef.current;
    if(emailElem && emailElem.querySelector('b')) {
      emailElem.querySelector('b').innerText = email;
    }
  }, [email]);

  useEffect(() => {
    const emailElem = emailRef2.current;
    if(emailElem && emailElem.querySelector('b')) {
      emailElem.querySelector('b').innerText = email;
    }
  }, [email]);

  const subtitle = useMemo(() => {
    if(upselPDF) {
      const text = window.paypalPayment ? locales[window.userLang].success_screen_text_14 : locales[window.userLang].success_screen_text_13;
      let updatedText;
      if (!window.paypalPayment) {
        updatedText = text.replace(/<b>.*<\/b>/, `<b>${email}</b>`);
      }
      return (
        <p
          className={s.subtitle}
          dangerouslySetInnerHTML={{ __html: updatedText }}
        ></p>
      )
    } else {
      return (
        <p
          className={s.subtitle}
          dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_2 }}
        ></p>
      )
    }
  }, [upselPDF]);

  const imageSrc = useMemo(() => {
    switch (language.substring(0, 2)) {
      case "ru":
        return darkTheme ? imgRUDark : imgRU;
      case "es":
        return darkTheme ? imgESDark : imgES;
      case "en":
        return darkTheme ? imgENDark : imgEN;
      default:
        return null;
    }
  }, [language]);

  return (
    <div className={s.successScreen}>
      <div className={s.container}>
        {/* <div className={s.header}> */}
          <Logo />
          {/* <div className={s.logo}></div> */}
        {/* </div> */}
        <div className={s.content}>
          <div className={s.check}></div>
          <h2 className={s.title} dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_1}} />
          {subtitle}
          <div className={s.instruction}>
            <div className={s.items}>
              <div className={s.item}>
                <div className={s.itemIcon}></div>
                <p
                  className={s.itemText}
                  dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_3 }}
                ></p>
              </div>

              <div className={s.item}>
                <div className={s.itemIcon}></div>
                <p
                  className={s.itemText}
                  dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_4 }}
                ></p>
              </div>

              <div className={s.item}>
                <div className={s.itemIcon}></div>
                <p
                  className={s.itemText}
                  dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_5 }}
                ></p>
              </div>

              <div className={s.item}>
                <div className={s.itemIcon}></div>
                <p
                  className={s.itemText}
                  dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_6 }}
                ></p>
              </div>
            </div>

            <div className={s.divider}></div>

            <div className={s.itemDot}>
              {window.paypalPayment ? (
                <p>
                  {locales[window.userLang].success_screen_text_12}
                </p>
              ) : (
                <p ref={emailRef} dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_7 }} />
              )}
            </div>

            <div className={s.itemDot}>
              {window.paypalPayment ? (
                <p dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_16 }} />
              ) : (
                <p ref={emailRef2} dangerouslySetInnerHTML={{ __html: locales[window.userLang].success_screen_text_15 }} />
              )}
            </div>

            <div className={s.policy}>
              {imageSrc && <img src={imageSrc} alt="log in" />}
            </div>
          </div>
        </div>
      </div>
      <div className={s.buttonWrapper}>
        <div className={s.button} onClick={goToPayment}>
          <p>{locales[window.userLang].success_screen_text_11}</p>
        </div>
      </div>
    </div>
  );
}

export default SuccessScreen;
